import axios from 'axios';
import store from '@/store';
import ApiError from '@/api/ApiError';

function getApiRequestBody(url, method, data) {
  const request = {
    method,
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-By': 'LATURI',
    },
    data,
    json: true,
    withCredentials: true,
  };
  return request;
}

export function fetchTransactionStatus(orderId) {
  const request = getApiRequestBody(
    `${process.env.VUE_APP_API_BASE_URL}/payments/${orderId}`,
    'GET',
    {}
  );
  return makeRequest(request);
}

export async function getRequest(
  path,
  mutations,
  commit,
  baseUrl = process.env.VUE_APP_API_BASE_URL
) {
  let success = true;
  const params = getApiRequestBody(`${baseUrl}${path}`, 'GET', {});
  commit(mutations.PENDING, true);
  commit(mutations.FAILURE, null);
  try {
    const res = await makeRequest(params);
    commit(mutations.SUCCESS, res.data);
  } catch (error) {
    console.error(error);
    success = false;
    if (error instanceof ApiError) {
      if (error.retry) {
        try {
          const res = await makeRequest(params);
          commit(mutations.SUCCESS, res.data);
          success = true;
        } catch (error) {
          if (error instanceof ApiError) {
            commit(mutations.FAILURE, error.error);
          } else {
            throw error;
          }
        }
      } else {
        commit(mutations.FAILURE, error.error);
      }
    } else {
      throw error;
    }
  }
  commit(mutations.PENDING, false);
  return success;
}
export async function postRequest(
  path,
  payload,
  mutations,
  commit,
  baseUrl = process.env.VUE_APP_API_BASE_URL
) {
  let success = true;
  const params = getApiRequestBody(`${baseUrl}${path}`, 'POST', payload);
  commit(mutations.PENDING, true);
  commit(mutations.FAILURE, null);
  try {
    const res = await makeRequest(params);
    commit(mutations.SUCCESS, res.data);
  } catch (error) {
    console.error(error);
    success = false;
    if (error instanceof ApiError) {
      if (error.retry) {
        try {
          const res = await makeRequest(params);
          commit(mutations.SUCCESS, res.data);
          success = true;
        } catch (error) {
          if (error instanceof ApiError) {
            commit(mutations.FAILURE, error.error);
          } else {
            throw error;
          }
        }
      } else {
        commit(mutations.FAILURE, error.error);
      }
    } else {
      throw error;
    }
  }
  commit(mutations.PENDING, false);
  return success;
}

function makeRequest(requestParams) {
  return axios(requestParams)
    .then(res => {
      if (res.data && res.data.error) {
        throw new ApiError(res.data.error);
      }
      return res.data;
    })
    .catch(handleErrors);
}
async function handleErrors(err) {
  const res = err.response;
  if (err instanceof ApiError) {
    throw err;
  }
  if (res) {
    if (res.status === 403) {
      await store.dispatch('user/authenticate', store.state.user.key);
      throw new ApiError('general_error', true);
    } else if (res.data && res.data.error) {
      throw new ApiError(res.data.error);
    }
  }
  throw new ApiError('general_error');
}
